'use client';
import { createContext, PropsWithChildren, useState } from 'react';
import { GalleryVariant, userSettings } from '../temp_userSettings';

type UserSetting = {
  galleryVariant: GalleryVariant;
  sideStats: boolean;
  specs: { [id: string]: { title: string; src } };
};

type Spec = {
  id: string;
  title: string;
  url: string;
  value: string;
};

type UserSpec = {
  id: string;
  title: string;
  src: string;
};

export const LotSettingsContext = createContext<
  [
    UserSetting,
    {
      setUserSettings: (setting: Spec) => void;
      removeUserSettings: (id: string) => void;
      removeUserSpec: (id: string) => void;
      setSetting: (setting: { [k: string]: any }) => void;
    }
  ]
>([
  {
    ...userSettings,
  },
  {
    setUserSettings: () => void {},
    removeUserSettings: () => void {},
    removeUserSpec: () => void {},
    setSetting: () => void {},
  },
]);

export const LotProvider: React.FC<
  PropsWithChildren<{ defaultOpen?: string }>
> = ({ children }) => {
  const [userSettings, s_userSetting] = useState(getSettings());

  const setSetting = (setting: { [k: string]: any }) => {
    const s = { ...getSettings(), ...setting };
    localStorage.setItem('userSettings', JSON.stringify(s));
    s_userSetting(s);
  };
  const setUserSpec = (spec: Spec) => {
    s_userSetting(setSettings_spec(spec));
  };
  const removeUserSpec = (id: string) => {
    s_userSetting(setSettings_spec(removeSettings(id)));
  };

  return (
    <LotSettingsContext.Provider
      value={[
        userSettings,
        {
          setUserSettings: setUserSpec,
          removeUserSettings: removeUserSpec,
          removeUserSpec,
          setSetting,
        },
      ]}
    >
      {children}
    </LotSettingsContext.Provider>
  );
};

function setSettings_spec(setting: Spec): UserSpec {
  let œ = getSettings(),
    { id, title, url, value } = setting;

  if (!id) return œ;

  œ = {
    ...œ,
    specs: { ...(œ.specs || {}), [id]: { src: url, title: title || value } },
  };
  localStorage.setItem('userSettings', JSON.stringify(œ));

  return œ;
}

function getSettings() {
  if (typeof window === 'undefined') return { ...userSettings };

  return {
    ...userSettings,
    ...JSON.parse(localStorage.getItem('userSettings') || '{}'),
  };
}

function removeSettings(id: string) {
  let œ = getSettings();
  delete œ.specs[id];
  œ = { ...œ, specs: { ...œ.specs } };
  localStorage.setItem('userSettings', JSON.stringify(œ));

  return œ;
}
